define('bindingHandlers/dataViz/components/svgContainer',[
    'jquery',
    'lib/d3',

    'util/domUtils'
], function (
    $,
    d3,

    domUtils
) {
    'use strict';

    var CONTENT_CLASS = "chart-content";

    return function renderSVGContainer (element, height) {
        var barChartSvg = d3.select(element)
                            .select("." + CONTENT_CLASS);

        var $element = $(element);
        var containerHeight = Math.max(height, $element.height());

        if (barChartSvg.empty()) {


            barChartSvg = d3.select(element)
                                .append("svg")
                                    .attr("class", "chart-svg-wrapper")
                                    .attr("width", $element.width() - domUtils.getScrollbarWidth())
                                    .attr("height", containerHeight)
                                .append("g")
                                    .attr("class", CONTENT_CLASS);
        }

        d3.select(element).select(".chart-svg-wrapper")
                            .attr("height", containerHeight);

        return barChartSvg;
    };
});
